
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/white-label-crypto-wallet",
      function () {
        return require("private-next-pages/white-label-crypto-wallet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/white-label-crypto-wallet"])
      });
    }
  